import ReleaseIndex from '@/views/fm/releases/Index'
import ReleaseDetail from '@/views/fm/releases/Detail'
import CustomersIndex from '@/views/fm/customers/Index'
import CustomersDetail from '@/views/fm/customers/Detail'
import PriceAgreementsIndex from '@/views/fm/price-agreements/Index'
import PriceAgreementsCustomers from '@/views/fm/customers/price-agreements/PriceAgreements'
import Administrations from '@/views/fm/customers/administrations/Administrations'
import Invoices from '@/views/fm/customers/invoices/Invoices'
import Report from '@/views/fm/report/Index'



export default
    [
        {
            name: 'fm:index',
            path: '/fm',
            component: {
                template: '<div><router-view /></div>'
            },
            children: [
                {
                    name: `releases:index`,
                    path: `releases`,
                    component: ReleaseIndex
                },
                {
                    name: `releases:detail`,
                    path: `releases/:releaseId`,
                    component: ReleaseDetail
                },
                {
                    name: `customers:index`,
                    path: `customers`,
                    component: CustomersIndex,
                },
                {
                    name: `price-agreements:index`,
                    path: `price-agreements`,
                    component: PriceAgreementsIndex,
                },
                {
                    name: `customers:detail`,
                    path: `customers/:companyId`,
                    component: CustomersDetail,
                    redirect: `customers/:companyId/administrations`,
                    children: [
                        {
                            name: `customers:detail:administrations`,
                            path: 'administrations',
                            component: Administrations
                        },
                        {
                            name: `customers:detail:price-agreements`,
                            path: 'price-agreements',
                            component: PriceAgreementsCustomers
                        },
                        {
                            name: `customers:detail:invoices`,
                            path: 'invoices',
                            component: Invoices
                        }
                    ]
                },
                {
                    name: `report:index`,
                    path: `report`,
                    component: Report,
                }
            ]
        }
    ]